/**
 * Constants for voip monitor service
 */

export const VOIP_CALL_QUALITY_TRACKS_INTERVAL = 2000 as const;
export const VOIP_CALL_QUALITY_SNAPSHOT_INTERVAL = 15000 as const;

export const MAX_METRICS_PER_CALL = 100;
export const MAX_CALLS_STORED = 50;